import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton, scrollToOffer } from './BuyButton';
import { EmailReviews } from './EmailReviews';
import { PRODUCT_IMAGE } from '../data/content';
const BADGES = [{
  icon: '📄',
  label: '100% PDF'
}, {
  icon: '⚡️',
  label: 'Instant Delivery'
}, {
  icon: '🧰',
  label: '6 Core Coaching Tools'
}];
export function Hero() {
  return <header className="relative px-5 pb-8 pt-8" data-id="element-143" data-mp="129qrndlnhbk6">
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="text-center font-display text-4xl font-800 uppercase leading-[0.95] text-white sm:text-5xl" data-id="element-144" data-mp="127ec173d7daa">
        Your Whole Pickleball Year,{' '}
        <span className="text-[var(--pb-lime)]" data-id="element-145" data-mp="3d33gp3txj3ne">Solved</span>
      </motion.h1>

      <motion.button type="button" onClick={scrollToOffer} initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} aria-label="View the offer and get the kit" className="mx-auto mt-6 block w-full max-w-md" data-id="element-146" data-mp="381e2jfbeu9v3">
        <img src={PRODUCT_IMAGE} alt="Pickleball Coach 360 — six ready-to-use systems for pickleball coaches" className="w-full rounded-2xl shadow-2xl shadow-black/50 ring-1 ring-white/20" data-id="element-147" data-mp="3e7uw1kyc2jmr" />
      </motion.button>

      <motion.p initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className="mx-auto mt-6 max-w-xl text-center text-base leading-relaxed text-white/95" data-id="element-148" data-mp="2qk3muq83ampp">
        Everything you need to coach better, save hours every week, and give
        every student a professional experience.
      </motion.p>

      <div className="mx-auto mt-5 flex max-w-md flex-wrap justify-center gap-2" data-id="element-149" data-mp="s3urnyvqxcbo">
        {BADGES.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-[#101b2d]/95 px-3 py-1.5 text-sm font-600 text-white shadow-md shadow-black/20" data-id="element-150" data-mp="ic891hh2wayw">
            <span aria-hidden data-id="element-151" data-mp="1azul7e4dgnxd">{b.icon}</span>
            {b.label}
          </span>)}
      </div>

      <div className="mx-auto mt-6 max-w-md" data-id="element-152" data-mp="162ufj4bfpn6s">
        <BuyButton data-id="element-153" data-mp="15zzvvf08w6ef" />
      </div>

      <EmailReviews data-id="element-154" data-mp="1126mkd3naw9x" />
    </header>;
}